import useFoodManagementModals from "@admin/hooks/useFoodManagementModals";
import {
  ControlPointCategory,
  FoodControlPointInstanceDto,
  InstanceStatus,
} from "@enos-monorepo/lib";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ControlPointModals } from "..";
import { AllControlsTableRow } from "./AllControlsTableRow";

interface AllControlsTableProps {
  type: ControlPointCategory;
  controlsOfType: FoodControlPointInstanceDto[];
}

export function AllControlsTable({
  type,
  controlsOfType,
}: AllControlsTableProps) {
  const { t } = useTranslation();
  const [waitingOnly, setWaitingOnly] = useState(false);
  const [currentInstance, setCurrentInstance] =
    useState<FoodControlPointInstanceDto>();

  const { openModal, closeModals, modalOpen } = useFoodManagementModals();

  const groupedInstancesByControlPoint = controlsOfType
    .filter((c) => !waitingOnly || c.status === InstanceStatus.waiting)
    .reduce<Record<string, FoodControlPointInstanceDto[]>>((acc, instance) => {
      const controlPointName = instance.controlPoint?.name ?? "unknown";
      if (!acc[controlPointName]) acc[controlPointName] = [];
      acc[controlPointName].push(instance);
      return acc;
    }, {});

  return (
    <div key={type} className="card card-grid min-w-full">
      <div className="card-header w-full py-5 flex-wrap justify-between">
        <div className="flex flex-row w-full items-center justify-between">
          <h3 className="card-title">{t(`food.${type}`)}</h3>
          <label className="switch switch-sm">
            <span className="switch-label">{t("food.Only Waiting")}</span>
            <input
              name="check"
              type="checkbox"
              value={0}
              onChange={() => setWaitingOnly((prev) => !prev)}
            />
          </label>
        </div>
      </div>
      <table className="table table-border table-fixed align-middle w-full">
        <tbody>
          <tr className="bg-[#FCFCFC]">
            <th className="text-center w-[150px]">{t("food.State")}</th>
            <th className="text-center">{t("food.Control Point")}</th>
            <th className="text-center">{t("food.Due Date")}</th>
            <th className="text-center w-[120px]"></th>
          </tr>
          {controlsOfType.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center text-gray-500">
                {t("common.No Data")}
              </td>
            </tr>
          ) : (
            Object.values(groupedInstancesByControlPoint).map(
              (instances, index) => (
                <AllControlsTableRow
                  key={index}
                  instances={instances}
                  setCurrentInstance={setCurrentInstance}
                  openModal={openModal}
                />
              ),
            )
          )}
        </tbody>
      </table>
      <ControlPointModals
        currentInstance={currentInstance}
        closeModals={closeModals}
        modalOpen={modalOpen}
      />
    </div>
  );
}
